import React from 'react';
import {
  Flex,
  Box,
  Stack,
  Container,
  Text,
  Heading,
  Button,
  Link,
} from '@chakra-ui/react';
import measurementImage from '../../images/MEASUREMENT-APP.webp';

interface LearnMoreSectionProps {
  title?: string;
  description?: string;
  ctaLink: string;
}

const LearnMoreSection = ({
  title,
  description,
  ctaLink,
}: LearnMoreSectionProps) => (
  <Box
    w="100%"
    textAlign="center"
    backgroundImage={measurementImage}
    backgroundSize="cover"
    backgroundPosition="center center"
    mt={['16', '20', '24']}
  >
    <Container maxW="8xl" px="12">
      <Stack
        as={Flex}
        textAlign="center"
        alignItems="center"
        spacing={8}
        py={[24, 36]}
      >
        <Heading
          fontWeight={700}
          color="white"
          fontSize={['2xl', '3xl', '4xl', '5xl']}
          lineHeight={['150%', '120%']}
        >
          {title}
        </Heading>
        <Text fontSize={['xl', '2xl', '3xl']} fontWeight="300" color="white">
          {description}
        </Text>
        <Link href={ctaLink}>
          <Button color="blue.400" bg="white" minW="64" size="lg">
            Learn more
          </Button>
        </Link>
      </Stack>
    </Container>
  </Box>
);

LearnMoreSection.defaultProps = {
  title: 'Transform your business with new workflow features',
  description:
    'From estimates and proposals to supplier-direct material ordering, HOVER helps you optimize and grow.',
};

export default LearnMoreSection;
